import React from 'react';
import { LoadingImage } from './style';
import LoaddingImg from '../../assets/images/loading.gif';

const Loading = () => <LoadingImage src={LoaddingImg} title="Carregando..." alt="Carregando..." />;

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js